// import axios from 'axios'
import { normalize } from 'normalizr'
import { fromJS } from 'immutable'
import { schemaProject } from '../schemas'
import axios from 'axios'
import { Notification } from 'element-ui'

/**
 * 新增项目
 * @param {*String} options.name 项目名称
 * @param {String} options.location 位置
 * @param {String} options.remark 备注
 * @param {String} options.adCode 备注
 * @param {String} options.equipmentName 项目用电设备名称（默认值：负载）
 */
export const create = async (options) => {
  const { data: { detail } } = await axios.post(`v2/projects`, options)
  const { entities } = normalize(detail, schemaProject)
  return fromJS(entities)
}

/**
 * 删除项目
 * @param {*String} projectId
 */
export const destroyById = async (projectId) => {
  await axios.delete(`v2/projects/${projectId}`)
}

/**
 * 修改项目
 * @param {*String} options.id 项目id
 * @param {*String} options.name 项目名称
 * @param {String} options.location 位置
 * @param {String} options.remark 备注
 * @param {String} options.adcode 省市区编码
 * @param {*String} options.equipmentName 项目用电设备名称（默认值：负载）
 * @param {Boolean} options.autoLocation 自动定位
 */
export const updateById = async (options) => {
  const { data: { detail } } = await axios.put(`v2/projects/${options.id}`, options)
  const { entities } = normalize(detail, schemaProject)
  return fromJS(entities)
}

/**
 * 获取项目列表
 * @param {String} options.queryParam 模糊查询参数
 * @param {*Number} options.pageNo 当前页
 * @param {*Number} options.pageSize 每页条数
 * @param {*Number} options.projectProductType 项目产品类型；-1-其他；0-恒流控制器；1-人体感应；2-市电互补；3-开关控制器 '' 全部
 */
export const findAll = async (options) => {
  const { data: { records } } = await axios.get(`v2/projects/list-mine-pagi?pageNo=${options.pageNo}&pageSize=${options.pageSize}&queryParam=${options.queryParam}&projectProductType=${options.projectProductType}`)
  const { entities } = normalize(records, [ schemaProject ])
  return fromJS(entities)
}
/**
 * 查询过期的项目列表
 */
export const solarMoteExpireList = async (options) => {
  let { data } = await axios.get('v2/solar-motes/pagiExpire', {
    params: {
      name: options.name,
      isDisabled: options.isDisabled,
      pageNo: options.pageNo,
      pageSize: options.pageSize,
      createStartDate: options.createStartDate,
      createEndDate: options.createEndDate,
      expireStartDate: options.expireStartDate,
      expireEndDate: options.expireEndDate
    }
  })
  console.log('查询过期的项目列表')
  return data
}
/**
 * 获取单个项目
 */
export const findById = async (projectId) => {
  const { data } = await axios.get(`v2/projects/${projectId}`)
  const { entities } = normalize(data, schemaProject)
  return fromJS(entities)
}

/**
 * 设置项目关注或者标签
 * @param {*String} projectId
 * @param {String} tag
 * @param {String} follow 是否关注；1-关注；0-不关注
 */
export const updateTagOrFollow = async (projectId, tag, follow) => {
  const data = await axios.post(`v2/projects/set-tag-or-follow/${projectId}`, { tag, follow })
  return data
}

/**
 * 新建老化测试
 * @param {*String} options.projectId 项目id
 * @param {*String} options.taskName 任务名
 * @param {*String} options.beginTime 开始时间（时间戳）
 * @param {*Number} options.frequency 轮询频率（分钟）
 * @param {*Number} options.duration 持续时间（小时）
 * @param {*String} options.email 邮箱
 */
export const createAgingTest = async (options) => {
  const data = await axios.post(`v1/tasks/project/aging-test`, options)
  return data
}

/**
 * 获取任务列表
 * @param {*String} options.taskType 任务类型: 2-老化测试
 */
export const findTasks = async () => {
  const { data } = await axios.get(`v1/tasks/list-task?taskType=2`)
  return data
}

/**
 * 终止列表
 * @param {*String} options.id 任务id
 */
export const shutDownTask = async (id) => {
  const { data } = await axios.put(`v1/tasks/shut-down/${id}`)
  return data
}

/**
 * 获取项目告警概览
 */
export const findProjectAlertOverview = async () => {
  const { data } = await axios.get(`v2/projects/list-project-alert-overview`)
  return data
}

/**
 * 根据adCode获取项目简略信息列表
 */
export const findProjectByAdcode = async (adCode) => {
  const { data } = await axios.get(`v2/projects/list-project-by-adcode?adCode=${adCode}`)
  return data
}

/**
 * 根据SN号获取设备关系链信息
 */
export const findRelationalBySnHex = async (snHex) => {
  let data = await axios.get(`/v2/solar-motes/get-mote-with-relational-chain-info?snHex=${snHex}`)
  if (data) {
    return data.data.detail
  } else {
    let data1 = await axios.get(`/repower/v2/solar-motes/get-mote-with-relational-chain-info?snHex=${snHex}`)
    if (!data1) {
      return Notification({
        title: '错误',
        message: '查找不到该设备',
        duration: 4000,
        type: 'error'
      })
    } else {
      return data1.data.detail
    }
  }
}
